import { useState } from "react"

export function useCallbackOnce(callback: () => void) {
  const [called, setCalled] = useState(false)

  function _callback() {
    if (called) return
    setCalled(true)
    callback()
  }

  return _callback
}
